import React from 'react';
import BannerDivision from './BannerDivision/BannerDivision';
import { rootConfig } from '../../../config/config';
import { BannerHolder } from '../StyledComponents/BannerHolder';

const banner = props => {
  // console.log('props: ', props);
  const { bannerData, clicked } = props;
  // console.log('bannerData: ', bannerData);
  let postData = [];
  let width;
  if (
    bannerData[0] &&
    bannerData[0].postDate &&
    bannerData[0].postAuthor.authorName &&
    bannerData[0].postTitle
  ) {
    // width = '100%';
    postData[0] = {
      postDate: bannerData[0].postDate,
      postTitle: bannerData[0].postTitle,
      authorName: bannerData[0].postAuthor.authorName,
      subTitle: bannerData[0].subTitle || null,
      rating: bannerData[0].rating || null
    };
  }
  // console.log('postData[0]: ', postData[0]);

  if (
    bannerData[1] &&
    bannerData[1].postDate &&
    bannerData[1].postAuthor.authorName &&
    bannerData[1].postTitle
  ) {
    // width = '50%';
    postData[1] = {
      postDate: bannerData[1].postDate,
      postTitle: bannerData[1].postTitle,
      authorName: bannerData[1].postAuthor.authorName,
      subTitle: bannerData[1].subTitle || null,
      rating: bannerData[1].rating || null
    };
  }

  if (
    bannerData[2] &&
    bannerData[2].postDate &&
    bannerData[2].postAuthor.authorName &&
    bannerData[2].postTitle
  ) {
    // width = '35%';
    postData[2] = {
      postDate: bannerData[2].postDate,
      postTitle: bannerData[2].postTitle,
      authorName: bannerData[2].postAuthor.authorName,
      subTitle: bannerData[2].subTitle || null,
      rating: bannerData[2].rating || null
    };
  }

  // Width of first banner
  // let width;
  // console.log('postData: ', postData);
  // if (postData[1] === undefined && postData[2] === undefined) {
  //   width = '100%';
  // } else if (postData[2] === undefined) {
  //   width = '50%';
  // } else {
  //   width = '35%';
  // }
  bannerData.length === 1
    ? (width = '100%')
    : bannerData.length === 2
    ? (width = '50%')
    : (width = null);
  // console.log('bannerData: ', bannerData);
  // console.log('width: ', width);
  return (
    <BannerHolder
      className="BannerHolder"
      // style={{ maxWidth: '1440px' }}
    >
      {bannerData.map((data, index) => {
        // console.log('data: ', data);
        if ((width === null || width === '35%') && index === 1) {
          width = '30%';
        }

        if (
          (width === null || width === '30%') &&
          (index === 0 || index === 2)
        ) {
          width = '35%';
        }

        let postData = {
          postDate: data.postDate,
          postTitle: data.postTitle,
          authorName: data.postAuthor ? data.postAuthor.authorName : '',
          subTitle: data.subTitle || null,
          rating: data.rating || null
        };
        // console.log('index: ', index);
        // console.log('width: ', width);

        return (
          <BannerDivision
            key={`${banner}-${index}`}
            postSlug={data.postSlug}
            bannerClicked={postSlug => clicked(postSlug)}
            width={width}
            url={
              data.featuredImage
                ? `${rootConfig.imagesRoot}/${data.featuredImage.file}`
                : null
            }
            postData={postData ? postData : {}}
          />
        );
      })}
      {/* <BannerDivision
        postSlug={bannerData[0].postSlug}
        bannerClicked={postSlug => clicked(postSlug)}
        width={width}
        url={
          bannerData[0].featuredImage
            ? `${rootConfig.imagesRoot}/${bannerData[0].featuredImage.file}`
            : null
        }
        postData={postData[0] ? postData[0] : {}}
      />
      {postData[1] ? (
        <BannerDivision
          postSlug={bannerData[1].postSlug}
          bannerClicked={postSlug => clicked(postSlug)}
          width="30%"
          url={
            bannerData[1].featuredImage
              ? `${rootConfig.imagesRoot}/${bannerData[1].featuredImage.file}`
              : null
          }
          postData={postData[1] ? postData[1] : {}}
        />
      ) : null}
      {postData[2] ? (
        <BannerDivision
          postSlug={bannerData[2].postSlug}
          bannerClicked={postSlug => clicked(postSlug)}
          width="35%"
          url={
            bannerData[2].featuredImage
              ? `${rootConfig.imagesRoot}/${bannerData[2].featuredImage.file}`
              : null
          }
          postData={postData[2] ? postData[2] : {}}
        />
      ) : null} */}
    </BannerHolder>
  );
};

export default banner;
